/* eslint-disable no-console */

export const sendMessage = async (awsConnectContactId, content) => {
  try {
    const res = await fetch('/ai/chatkit_messages', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ aws_connect_contact_id: awsConnectContactId, content })
    });
    return res.ok;
  } catch (error) {
    console.error('Error sending AWS Connect message:', error);
    return false;
  }
};
